import { render, staticRenderFns } from "./withdraw-main-chart-card.vue?vue&type=template&id=22c6951c&"
import script from "./withdraw-main-chart-card.vue?vue&type=script&lang=js&"
export * from "./withdraw-main-chart-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "withdraw-main-chart-card.vue"
export default component.exports